import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class EstimateListService {

  constructor(private http: HttpClient) {}

  getCategoriesAndSubCategories(): Observable<any> {
    return this.http.get(`${GlobalVariable.BASE_API_URL}` + '/api/v1/service/getCategoriesAndSubCategories');
  }

  getServices(payload: any): Observable<any> {
    return this.http.post(`${GlobalVariable.BASE_API_URL}` + '/api/v1/service/getServices?page=0&size=10&sort=id', payload);
  }
}
